'use client'
import React, { HTMLAttributes, ReactElement, ReactNode } from 'react'
import { Text } from '../../../atoms'
import { TextTypes } from '../../../../types'

interface DataListHeaderProps extends HTMLAttributes<HTMLLIElement> {
    children: ReactNode
    isSticky?: boolean
}

export const DataListHeader = ({ children, isSticky, ...rest }: DataListHeaderProps): ReactElement => {
    const classNames: string = `${rest.className ?? ''} ${isSticky ? 'sticky top-0 bg-white z-10' : ''}`

    return (
        <li className={classNames}>
            <Text className="px-6 py-2 border-b border-shade-200" type={TextTypes.HEADING_6}>
                <span className="text-xs text-text-tertiary">{children}</span>
            </Text>
        </li>
    )
}
